import api from 'common/api';

export const getFilterContainerAPI = (params: any) => api.get('/container-status/list', params);

export const updateFilterContainerAPI = (params: any) => api.put('/container-status', params);
